module.exports = __webpack_public_path__ + "img/logo.7b5928e4.svg";